export const SETTINGS_INIT_STATE = {
  chargeBalanceFees: 0,
  activeAuctionsTap: "timed",
};
